import React from 'react';
import DashboardLayout from '../DashboardLayout';

const SalesLayout: React.FC = () => {
    return (
        <DashboardLayout />
    );
};

export default SalesLayout;
